import type { ReactNode } from 'react';

import { Text } from '@sravni/react-design-system/lib/Typography';

import styles from './SeoGuideCard.module.scss';

export function SeoGuideCard({
  icon,
  title,
  description,
  actions,
}: {
  icon: ReactNode;
  title: ReactNode;
  description: ReactNode;
  actions?: ReactNode;
}) {
  return (
    <div className={styles.container}>
      <div className={styles.iconContainer}>{icon}</div>
      <div className={styles.content}>
        <Text className={styles.title}>{title}</Text>
        <Text className={styles.description}>{description}</Text>
      </div>

      {actions && <div className={styles.actions}>{actions}</div>}
    </div>
  );
}
